import {useTranslation} from 'react-i18next';
import './ArrivalNotFound.scss';

interface ArrivalNotFoundProps {
    onClose?: VoidFunction;
}

export function ArrivalNotFound({onClose}: ArrivalNotFoundProps) {
    const {t} = useTranslation();
    const texts = t('arrival.booking_result.not_found', {returnObjects: true}) as string[];

    setTimeout(async () => {
        if (onClose) {
            onClose();
        }
    }, 7500);

    return (
        <div className='arrival-notfound'>
            <h2 className='arrival-notfound__heading'>{t('arrival.booking_result.not_found_heading')}</h2>
            <div className='arrival-notfound__queue-box'>
                <span className='crossmark'>&times;</span>
            </div>

            <div className='arrival-notfound__text'>
                {texts.map((txt, ix) => (
                    <p key={ix} dangerouslySetInnerHTML={{__html: txt}} />
                ))}
            </div>
        </div>
    );
}
